<template>
  <div class="main">
    <div class="title">教师试卷</div>
    <el-form :model="ruleForm"
             ref="ruleForm"
             label-width="100px"
             class="demo-ruleForm">
      <el-form-item label="科目"
                    style="width: 20%;"
                    prop="subject_ids">
        <el-select style="width:100%"
                   v-model="ruleForm.subject_ids"
                   clearable
                   @change="change"
                   placeholder="选择科目">
          <el-option v-for="item in subjectList"
                     :key="item.subject_id"
                     :label="item.subject_name"
                     :value="item.subject_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="试卷"
                    style="width: 20%;"
                    prop="subject_ids">
        <el-select style="width:100%"
                   v-model="ruleForm.edu_paper_id"
                   clearable
                   multiple
                   @change="changePaper"
                   placeholder="选择试卷">
          <el-option v-for="item in paperList"
                     :key="item.edu_paper_id"
                     :label="item.paper_name"
                     :value="item.edu_paper_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="submitForm('ruleForm')">确定</el-button>
        <el-button @click="goback()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getTeacherList, getDetectionList, doTeacherList } from '@/api/dataAnalysis.js'
export default {
  data () {
    return {
      ruleForm: {
        subject_ids: '',
        edu_paper_id: '',
        detection_id: ''
      },
      rules: {
        edu_paper_id: [
          { required: true, message: '请输入检测报告', trigger: 'blur' },
        ],
        subject_ids: [
          { required: true, message: '请选择科目', trigger: 'change' }
        ],
      },
      subjectList: [],
      paperList: [],
      edu_paper_id_list: []
    };
  },
  async created () {
    const { data } = await getDetectionList({ detection_id: this.$route.query.detection_id })
    this.subjectList = data.list
  },
  mounted () {
    // document.getElementsByClassName('home_right')[0].style.background = '#f6f6f6'
    // document.getElementsByClassName('top_nav')[0].style.background = '#FFFFFF'
    // // document.getElementsByClassName('view_warp')[0].style.background = '#FFFFFF'
    // document.getElementsByClassName('view_warp')[0].style.margin = '24px'
    // document.getElementsByClassName('view_warp')[0].style.marginTop = '34px'
    // document.getElementsByClassName('view_warp')[0].style.height = 'auto'
    // document.getElementsByClassName('el-breadcrumb')[0].style.marginTop = '110px'
    // document.getElementsByClassName('right_select')[0].style.lineHeight = '5'
    // document.getElementsByClassName('left_icon')[0].style.marginLeft = '2px'
    // document.getElementsByClassName('el-breadcrumb')[0].style.marginLeft = '8px'
  },
  methods: {
    goback () {
      this.$router.go(-1)
    },
    changePaper (val) {
      this.edu_paper_id_list = val

    },
    async change (val) {
      this.ruleForm.edu_paper_id = ''
      const { data } = await getTeacherList({ subject_id: val, detection_id: this.$route.query.detection_id })
      this.paperList = data.list
    },
    submitForm (formName) {
      this.$refs[formName].model.detection_id = this.$route.query.detection_id
      this.$refs[formName].validate((valid) => {
        let promises = [];
        this.edu_paper_id_list.forEach(item => {
          let params = {
            detection_id: this.$route.query.detection_id,
            edu_paper_id: item,
            subject_ids: this.ruleForm.subject_ids
          };
          console.log(params);
          if (valid) {
            promises.push(this.$http({
              url: '/api/v1/tang/do_two',
              method: 'post',
              data: params
            }));
          } else {
            this.$notify({
              title: '提示',
              message: '提交失败!',
              type: 'error'
            });
            return false;
          }
        });

        Promise.all(promises)
          .then(responses => {
            // 检查所有请求是否都成功
            console.log(responses);
            let allSuccessful = responses.every(response => response.status == 200 );
            console.log('ss', allSuccessful);
            if (allSuccessful) {
              // 所有请求成功后执行的操作
              this.$notify({
                title: '提示',
                message: '提交成功!',
                type: 'success'
              });
              console.log('All requests successful', responses);
              // 在所有请求成功后跳转路由
              this.$router.go(-1);
            }
          })
          .catch(error => {
            this.$notify({
              title: '提示',
              message: '提交失败!',
              type: 'error'
            });
          });
      });
    },
    async postData (params) {
      await doTeacherList(params)
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  font-family: Regular;
  // padding: 24px 24px 0 24px;
  padding: 12px;
  background: white;
  .title {
    top: 142px;
    left: 256px;
    width: 80px;
    height: 30px;
    // background: rgba(17, 17, 17, 1);
    margin: 8px 0px 30px 12px;
    color: rgba(17, 17, 17, 1);
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
  }
}
::v-deep .el-form-item__label {
  font-size: 14px !important;
}
::v-deep .el-breadcrumb {
  margin-left: 5px;
}
::v-deep .el-button {
  padding: 0;
  width: 60px;
  height: 32px;
  margin-top: 16px;
}
</style>